<template>
    <div class="movie-view relative bg-theme-gray w-full flex h-full pb-40">
        <div class="w-full h-auto  flex flex-col items-center">
            <section class="w-956">
                <p class="text-sm text-txt-lightgray m-5"><router-link class="hover:underline" to="/">HOME</router-link> >
                    <span class="text-txt-gray">【動画】{{ category_name }}</span>
                </p>
            </section>
            <section class="w-956 flex justify-center">
                <div class="w-16 mx-1 mb-2 opacity-80 hover:opacity-100 transition uration-300"
                    v-for="videolink in videolinks" :key="videolink.id">
                    <!--<a href={{videolink.web_mov_cat}}><img class='' :src="videolink.img"></a>-->
                    <router-link
                        :to="{ name: 'Movie', query: { operationtype: 'category', web_mov_cat: videolink.id } }"><img
                            class='' :src="videolink.img"></router-link>
                    <!--<router-link class="hover:underline" :to="videolink.url">aaaa</router-link>-->
                </div>
            </section>
            <section class=" w-956">
                <div class="w-full p-5 flex flex-wrap">
                    <div class="w-290 h-150 rounded mx-1 mb-10 bg-theme-darkgray opacity-100 flex flex-col hover:opacity-70 transition uration-300"
                        v-for="item in state.items" :key="item.id">
                        <a :href="item.url" target="_blank" class="flex items-center flex-col">
                            <img :src="img_path + item.img" class="w-150 h-150">
                        </a>
                        <p class="text-sm text-txt-gray">{{ item.web_mov_displayname }}</p>
                        <!--<video controls v-if="item.url">-->
                        <!--  <source :src="item.url" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>-->
                        <!--</video>-->
                    </div>
                </div>
            </section>
            <section class="w-956">
                <p class="text-sm text-txt-lightgray m-5"><router-link class="hover:underline" to="/">HOME</router-link> >
                    <span class="text-txt-gray">【動画】{{ category_name }}</span>
                </p>
            </section>
        </div>
    </div>

    <Footer></Footer>
</template>
<script>
import Footer from '@/components/Footer.vue';
import { useRoute } from 'vue-router'
import { ref, watchEffect, reactive } from 'vue';
import axios from 'axios'

export default {
    components: {
        Footer
    },
    name: 'movieview',
    data: () => ({
        videolinks: [
            // { id: 'Prevention', name: 'video_Prevention', img: 'img/video_Prevention.png' },
            { id: 'Accessory', name: 'video_Accessory', img: 'img/video_Accessory.png' },
            { id: 'Desk', name: 'video_Desk', img: 'img/video_Desk.png' },
            { id: 'Table', name: 'video_Table', img: 'img/video_Table.png' },
            { id: 'Chair', name: 'video_Chair', img: 'img/video_Chair.png' },
            { id: 'Lobby', name: 'video_Lobby', img: 'img/video_Lobby.png' },
            { id: 'MeetingChair', name: 'video_MeetingChair', img: 'img/video_MeetingChair.png' },
            { id: 'Partition', name: 'video_Partition', img: 'img/video_Partition.png' },
            { id: 'Board', name: 'video_Board', img: 'img/video_Board.png' },
            { id: 'Storage', name: 'video_Storage', img: 'img/video_Storage.png' },
            // {id: 'Counter', name: 'video_Counter', img: 'img/video_Counter.png'},
            // { id: 'Emergency', name: 'video_Emergency', img: 'img/video_Emergency.png' },
        ]
    }),
    setup() {
        const route = useRoute()
        const category_param = ref(route.query.web_mov_cat)
        const group_id = ref(route.query.cassette_id)
        const category_name = ref('')
        const web_mov_cat = ref('')
        // let group_name = ref('')
        const img_path = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/500/";

        watchEffect(() => {
            category_param.value = route.query.web_mov_cat
            group_id.value = route.query.cassette_id

            // クエリパラメーターからカテゴリ名を作成
            switch (category_param.value) {
                case 'Outlet':
                    category_name.value = 'アウトレット'
                    break
                // case 'Prevention':
                //     category_name.value = '感染対策用品'
                //     break
                case 'Accessory':
                    category_name.value = 'アクセサリー'
                    break
                case 'Desk':
                    category_name.value = 'デスク・デスク周辺'
                    break
                case 'Table':
                    category_name.value = 'テーブル'
                    break
                case 'Chair':
                    category_name.value = 'チェア'
                    break
                case 'Lobby':
                    category_name.value = '応接・ロビー'
                    break
                case 'MeetingChair':
                    category_name.value = 'ミーティングチェア'
                    break
                case 'Partition':
                    category_name.value = 'パーティション'
                    break
                case 'Board':
                    category_name.value = 'ボード'
                    break
                case 'Storage':
                    category_name.value = '収納'
                    break
                case 'Counter':
                    category_name.value = 'カウンター'
                    break
                // case 'Emergency':
                //     category_name.value = '防災用品'
                //     break
                default:
                    category_name.value = ''
                    break
            }
            //タイトル変更
            document.title = category_name.value + "の動画｜イチオシ";

        })
        // const test2 = "bbbbb";


        let url = ref('')
        // const url = "https://uu431sgkag.execute-api.ap-northeast-1.amazonaws.com/query/query?operationtype=category&web_mov_cat="+category_param.value;
        const state = reactive({
            data: null,
            items: null,
            cassette_block: null,
            product_name: null,
            maker_name: null,
            cassette_comment01: null,
            cassette_comment02: null,
            cassette_comment03: null,
            cassette_img01: null,
            cassette_img02: null,
            cassette_img03: null,
            cassette_img04: null
        })

        watchEffect(() => {
            web_mov_cat.value = route.query.web_mov_cat
            url = "https://uu431sgkag.execute-api.ap-northeast-1.amazonaws.com/query/query?operationtype=category&web_mov_cat=" + web_mov_cat.value;
            async function getitems() {
                state.data = await axios.get(url)

                state.items = state.data.data.Items.reverse()

                state.items = Object.values(state.items);
                // console.dir(state.items[0]);

                state.web_mov_cat = state.items[0].web_mov_cat
                state.web_mov_displayname = state.items[0].web_mov_displayname
                state.url = state.items[0].url
                state.id = state.items[0].id
                state.maker_name = state.items[0].maker_name
                state.bikou = state.items[0].bikou
                state.img = img_path + state.items[0].img

                // console.log(state.items);
            }

            getitems()
        })


        return {
            category_param,
            category_name,
            watchEffect,
            state,
            img_path
            // product_name,
            // maker_name,
            // cassette_comment01,
            // cassette_comment02,
            // cassette_comment03,
            // cassette_img01,
            // cassette_img02,
            // cassette_img03,
            // cassette_img04,
            // maker_name
        }
    }

}
</script>